import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ContentModel } from "@tSchaedlerYesco/Services/ContentSearchService";

import { Draft } from "immer";

export type CustomContentSearchResultType = {
    isLoading: boolean;
    contents: ContentModel[];
    requestCompleted?: boolean;
    query: string;
};
const initialState: CustomContentSearchResultType = {
    isLoading: false,
    contents: [],
    requestCompleted: false,
    query: "",
};

const reducer = {
    "Custom/SearchResults/StartFetchingContents": (draft: Draft<CustomContentSearchResultType>) => {
        draft.isLoading = true;
    },
    "Custom/SearchResults/SetContents": (draft: Draft<CustomContentSearchResultType>, action: { contents: any[] }) => {
        draft.contents = action.contents;
        draft.isLoading = false;
        draft.requestCompleted = true;
    },
    "Custom/SearchResults/UpdateContentsQuery": (
        draft: Draft<CustomContentSearchResultType>,
        action: { query: string },
    ) => {
        draft.query = action.query;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
